import { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import Card from 'app/frontend/base/components/Card'

type Props = {
  index: number
  label: ReactNode
  className?: string
  endSlot?: ReactNode
  warning?: boolean
}

const AssignmentEntityChip = ({
  index,
  label,
  className,
  endSlot,
  warning,
}: Props) => {
  return (
    <Card
      className={cn(
        'flex min-w-0 items-stretch overflow-hidden text-sm p-0',
        warning ? 'bg-warning hover:bg-warning' : '',
        className,
      )}
    >
      <span
        className={cn(
          'inline-flex w-8 shrink-0 items-center justify-center border-r tabular-nums',
          warning ? 'bg-warning hover:bg-warning' : 'border-border',
        )}
      >
        {index + 1}
      </span>
      <span className='inline-flex min-w-0 flex-1 items-center overflow-hidden px-2 py-1'>
        {label}
      </span>
      {endSlot ? (
        <span
          className={cn(
            'inline-flex items-center border-l px-1',
            warning ? 'bg-warning hover:bg-warning' : 'border-border',
          )}
        >
          {endSlot}
        </span>
      ) : null}
    </Card>
  )
}

export default AssignmentEntityChip
